const CODE128_PATTERNS = [
  "212222","222122","222221","121223","121322","131222","122213","122312","132212","221213",
  "221312","231212","112232","122132","122231","113222","123122","123221","223211","221132",
  "221231","213212","223112","312131","311222","321122","321221","312212","322112","322211",
  "212123","212321","232121","111323","131123","131321","112313","132113","132311","211313",
  "231113","231311","112133","112331","132131","113123","113321","133121","313121","211331",
  "231131","213113","213311","213131","311123","311321","331121","312113","312311","332111",
  "314111","221411","431111","111224","111422","121124","121421","141122","141221","112214",
  "112412","122114","122411","142112","142211","241211","221114","413111","241112","134111",
  "111242","121142","121241","114212","124112","124211","411212","421112","421211","212141",
  "214121","412121","111143","111341","131141","114113","114311","411113","411311","113141",
  "114131","311141","411131","211412","211214","211232","2331112",
];

const EAN_L = ["0001101","0011001","0010011","0111101","0100011","0110001","0101111","0111011","0110111","0001011"];
const EAN_G = ["0100111","0110011","0011011","0100001","0011101","0111001","0000101","0010001","0001001","0010111"];
const EAN_R = ["1110010","1100110","1101100","1000010","1011100","1001110","1010000","1000100","1001000","1110100"];
const EAN_PARITY = ["LLLLLL","LLGLGG","LLGGLG","LLGGGL","LGLLGG","LGGLLG","LGGGLL","LGLGLG","LGLGGL","LGGLGL"];

export function isValidEan13(value) {
  if (!/^\d{13}$/.test(value)) return false;
  const digits = [...value].map(Number);
  const sum = digits.slice(0, 12).reduce((total, digit, index) => total + digit * (index % 2 === 0 ? 1 : 3), 0);
  return (10 - (sum % 10)) % 10 === digits[12];
}

function ean13Bits(value) {
  const first = Number(value[0]);
  const parity = EAN_PARITY[first];
  let bits = "101";
  for (let index = 1; index <= 6; index += 1) {
    const digit = Number(value[index]);
    bits += parity[index - 1] === "L" ? EAN_L[digit] : EAN_G[digit];
  }
  bits += "01010";
  for (let index = 7; index <= 12; index += 1) bits += EAN_R[Number(value[index])];
  return `${bits}101`;
}

function code128Bits(value) {
  const codes = [...value].map((char) => char.charCodeAt(0) - 32);
  if (!codes.length || codes.some((code) => code < 0 || code > 94)) return null;
  const checksum = (104 + codes.reduce((sum, code, index) => sum + code * (index + 1), 0)) % 103;
  return [104, ...codes, checksum, 106].map((code) => {
    let bar = true;
    let bits = "";
    for (const width of CODE128_PATTERNS[code]) {
      bits += (bar ? "1" : "0").repeat(Number(width));
      bar = !bar;
    }
    return bits;
  }).join("");
}

export function createBarcode(value) {
  const normalized = String(value ?? "").trim();
  if (!normalized) return null;
  const format = isValidEan13(normalized) ? "EAN-13" : "CODE128";
  const bits = format === "EAN-13" ? ean13Bits(normalized) : code128Bits(normalized);
  if (!bits) return { value: normalized, format, error: "Bu barkod görsel olarak oluşturulamıyor." };
  const bars = [];
  let start = null;
  for (let index = 0; index <= bits.length; index += 1) {
    if (bits[index] === "1" && start === null) start = index;
    if (bits[index] !== "1" && start !== null) {
      bars.push({ x: start + 10, width: index - start });
      start = null;
    }
  }
  return { value: normalized, format, bars, width: bits.length + 20 };
}
